import { http } from "../../../shared/api/http";

export async function updateItemStatus(id:any,data:any): Promise<any> {
  const res = await http.put(`/waiter/orders/${id}/items/status`,data);
  return res.data;
}